"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var reactjs_popup_1 = __importDefault(require("reactjs-popup"));
require("../../components/Admin/Knowledge/Style/style.scss");
var icons_1 = __importDefault(require("../../theme/icons"));
var Button_1 = __importDefault(require("../Button/Button"));
var Modal = function (_a) {
    var title = _a.title, onCloseClick = _a.onCloseClick, onSaveClick = _a.onSaveClick, children = _a.children, triggerButton = _a.triggerButton;
    var t = (0, react_i18next_1.useTranslation)().t;
    function ModalHeader(closeEvent) {
        return (react_1.default.createElement("div", { className: "modal-header" },
            react_1.default.createElement("div", { className: "modal-title" },
                " ",
                t(title),
                " "),
            react_1.default.createElement("div", { style: {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                } },
                onSaveClick && (react_1.default.createElement(Button_1.default, { onClick: onSaveClick, className: "modal-button", style: { marginRight: "1vw" }, icon: react_1.default.createElement(icons_1.default, { name: "tick", className: "icon", height: 30, width: 30 }) })),
                react_1.default.createElement(Button_1.default, { onClick: function () {
                        closeEvent();
                        onCloseClick();
                    }, className: "modal-button", icon: react_1.default.createElement(icons_1.default, { name: "cancel", className: "icon", height: 20, width: 20 }) }))));
    }
    return (react_1.default.createElement(reactjs_popup_1.default, { modal: true, nested: true, trigger: triggerButton, contentStyle: {
            width: "100%",
            background: "transparent",
            border: "none",
            padding: 0,
        } }, function (close) { return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "modal-card" },
            ModalHeader(close),
            react_1.default.createElement("div", { className: "content" }, children)))); }));
};
exports.default = Modal;
